import { reactive, watchEffect } from "vue";
import Highcharts from "highcharts";

const DARK_KEY = "dark-mode";
const PIN_KEY = "sidebar-pinned";

// State tampilan yang dipakai bersama oleh sidebar dan topbar.
export const theme = reactive({
  isDark: localStorage.getItem(DARK_KEY) === "true",
  sidebarPinned: localStorage.getItem(PIN_KEY) === "true",
  sidebarMobileOpen: false,
});

export function toggleDark() {
  theme.isDark = !theme.isDark;
}

export function toggleSidebarPin() {
  theme.sidebarPinned = !theme.sidebarPinned;
}

// Hanya mengatur tipografi, latar, dan warna teks/garis; warna seri tidak diubah.
function chartTheme(isDark) {
  const text = isDark ? "#e2e8f0" : "#1e293b";
  const muted = isDark ? "#94a3b8" : "#64748b";
  const line = isDark ? "#1e293b" : "#e2e8f0";
  const axis = {
    labels: { style: { color: muted } },
    title: { style: { color: muted } },
    lineColor: line,
    tickColor: line,
    gridLineColor: line,
  };
  return {
    chart: {
      backgroundColor: "transparent",
      style: { fontFamily: "Poppins, sans-serif" },
    },
    title: { style: { color: text, fontSize: "14px", fontWeight: "600" } },
    subtitle: { style: { color: muted } },
    xAxis: axis,
    yAxis: axis,
    legend: {
      itemStyle: { color: text, fontWeight: "500" },
      itemHoverStyle: { color: muted },
    },
    tooltip: {
      backgroundColor: isDark ? "#0f172a" : "#ffffff",
      borderColor: line,
      style: { color: text },
    },
    navigation: {
      buttonOptions: {
        symbolStroke: muted,
        theme: { fill: "transparent" },
      },
    },
  };
}

watchEffect(() => {
  document.documentElement.classList.toggle("dark", theme.isDark);
  localStorage.setItem(DARK_KEY, String(theme.isDark));

  const options = chartTheme(theme.isDark);
  Highcharts.setOptions(options);
  Highcharts.charts.forEach((chart) => chart && chart.update(options));
});

watchEffect(() => {
  document.documentElement.style.setProperty(
    "--sidebar-w",
    theme.sidebarPinned ? "16rem" : "4.5rem"
  );
  localStorage.setItem(PIN_KEY, String(theme.sidebarPinned));
});
